import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useHotelAdminStore } from '../store'
import { apiClient } from '../services/apiClient'
import { extractErrorMessage } from '../utils/errorHandler'

export default function AdminVerifyEmailPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const admin = useHotelAdminStore((state) => state.admin)

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const verificationToken = searchParams.get('token')

  useEffect(() => {
    const verifyEmail = async () => {
      if (!verificationToken) {
        setError('Токен верификации не найден')
        setIsLoading(false)
        return
      }

      try {
        setIsLoading(true)
        const response = await apiClient.verifyEmail(verificationToken)

        if (response.status === 'ok') {
          setSuccess(true)
          
          // Redirect to subscription page after 2 seconds
          setTimeout(() => {
            navigate('/admin-subscription-select')
          }, 2000)
        } else {
          setError(response.detail || 'Ошибка верификации')
        }
      } catch (err: any) {
        console.error('Verification error:', err)
        setError(extractErrorMessage(err) || 'Ошибка при верификации')
      } finally {
        setIsLoading(false)
      }
    }

    verifyEmail()
  }, [verificationToken, navigate])

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-600 to-blue-600 p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800">🏨 HotelsProd</h1>
            <h2 className="text-xl font-semibold text-gray-600 mt-2">Подтверждение email</h2>
          </div>

          {isLoading && (
            <div className="py-12">
              <div className="inline-block">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
              </div>
              <p className="text-gray-600 mt-6">Проверяем ваш email...</p>
            </div>
          )}

          {success && !isLoading && (
            <div className="py-8">
              <div className="text-5xl mb-6">✅</div>
              <h3 className="text-2xl font-bold text-green-600 mb-3">Email подтвержден!</h3>
              <p className="text-gray-600 mb-6">
                Спасибо за верификацию. Теперь выберите тариф подписки для активации вашего аккаунта.
              </p>
              <p className="text-sm text-gray-500">Перенаправление на выбор плана...</p>
            </div>
          )}

          {error && !isLoading && (
            <div className="py-8">
              <div className="text-5xl mb-6">❌</div>
              <h3 className="text-2xl font-bold text-red-600 mb-3">Ошибка верификации</h3>
              <p className="text-gray-600 mb-6">{error}</p>
              <div className="space-y-3">
                <button
                  onClick={() => navigate('/admin-login')}
                  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-lg transition"
                >
                  Вернуться на вход
                </button>
                <p className="text-xs text-gray-500">
                  Если у вас возникли проблемы, обратитесь в поддержку
                </p>
              </div>
            </div>
          )}

          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-xs text-gray-500">
              Статус: {admin?.email || 'Не авторизован'}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
